export const FETCH_CAST_MEMBERS_LIST_START = 'cast-members/FETCH_CAST_MEMBERS_LIST_START'
export const FETCH_CAST_MEMBERS_LIST_COMPLETED = 'cast-members/FETCH_CAST_MEMBERS_LIST_COMPLETED'
export const SET_IS_FETCHING_CAST_MEMBER_DETAILS = 'cast-members/SET_IS_FETCHING_CAST_MEMBER_DETAILS'
